
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","viewBox":"0 0 22 22"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"d":"M8.268 2.604L3.328 6.45a4.362 4.362 0 00-1.494 3.047v6.792a3.873 3.873 0 003.859 3.868h10.614a3.871 3.871 0 003.859-3.859V9.625a4.329 4.329 0 00-1.65-3.162l-5.665-3.969a4.113 4.113 0 00-4.583.11z"}}),_c('path',{attrs:{"d":"M11 16.491V13.74","opacity":".4"}})])])
          )
        }
      }
    